import { Button, Col, Container, DropdownItem, Row } from "reactstrap";
import styles from "./style.module.scss";
import { faArrowCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import { ReactNode } from "react";
import cx from "classnames";
import DropdownActionsMenu, { MenuActionProps } from "@components/content/DropdownMenu";

type PageProps = {
  title: string;
  backUrl: string;
  primaryActions?: MenuActionProps[];
  secondaryActions?: MenuActionProps[];
  containerClassName?: string;
} & React.HTMLAttributes<HTMLAnchorElement>;

const PageContainer = (props: PageProps) => {
  const navigate = useNavigate();
  const { onClick, backUrl, title, children, primaryActions = [],
    secondaryActions = [], className, containerClassName } = props;

  const renderPrimaryActions = (): ReactNode[] => {
    return primaryActions.map((a, index) => {
      const node = renderAction(a);
      return <span key={a.actionTitle ?? `action-${index}`} className="d-inline-block">{node}</span>;
    });
  }

  const renderAction = (action: MenuActionProps): ReactNode => {
    if (action.customElement) {
      return action.customElement
    }
    if (action.href) {
      return (
        <DropdownItem onClick={() => navigate(`${action.href}`)}>
          {action.actionTitle}
        </DropdownItem>
      )
    } else {
      const { type = "button", color = "primary" } = action
      return (
        <Button
          disabled={action.disabled}
          onClick={action.onClick}
          className={styles.button}
          color={color}
          type={type}
          form={action.formId}
        >
          {action.actionTitle}
        </Button>
      )
    }
  }

  const renderSecondaryActions = (): ReactNode => {
    return (
      <DropdownActionsMenu
        actions={secondaryActions}
      />
    )
  }

  return (
    <Container className={cx(["page-container", className])} fluid>
      <Row>
        <Col
          className={cx(["main-container", styles.container])}
          md="12"
        >
          <div className={cx(["page-header", styles.header])}>
            <Link to={backUrl} onClick={onClick} className={styles.headerLink}>
              <FontAwesomeIcon icon={faArrowCircleLeft} />
            </Link>
            <div className={styles.spliter}></div>
            <div className={styles.title}>
              {title}
            </div>
            <div className={styles.acciones}>
              {renderPrimaryActions()}
              {secondaryActions.length > 0 ? (<div className={styles.spliter}></div>) : false}
              {secondaryActions.length > 0 ? renderSecondaryActions() : false}
            </div>
          </div>
          <div className={cx(["page-content", styles.content, containerClassName])}>
            {children}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default PageContainer;